import React, {Component} from 'react';
import { DropdownButton, MenuItem, Form, FormGroup, ControlLabel, FormControl, Button } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import './Print.css';
import Select from 'react-select';
import { Checkbox } from 'react-icheck';
import LazyLoad from 'react-lazyload'

var MobileDetect = require('mobile-detect')
class PrintPreview extends Component {

  constructor(...args){
    super(...args)

    let md = new MobileDetect(window.navigator.userAgent);
    if(md.is('iOS') || md.is("AndroidOS")){
      var body_print = "body-print"
      var headerContent_fix = "headerContent-fix"
      var footerContent = "footerContent"
    } else {  
      var body_print = "body-print-desktop"
      var headerContent_fix = "headerContent-fix-desktop"
      var footerContent = "footerContent-desktop"
    }

    let disPerPage = 'none'
    if (this.props.onRowsPerPageChange!==undefined) {
      disPerPage = ''
    }

    let disTypePrint = 'none'
    if (this.props.onTypePrintChange!==undefined) {
      disTypePrint = ''
    }

    const optionsRows = [];
    for (var i=this.props.startRowPerPage;i<=this.props.endRowPerPage;i++) {
      optionsRows.push(i)
    }
    this.state = {
      body_print:body_print,
      headerContent_fix:headerContent_fix,
      footerContent:footerContent,
      disPerPage:disPerPage,
      optionsRows:optionsRows,
      defaultRows: this.props.defaultRowPerPage,
      defaultTypePrint: this.props.defaultTypePrint,
      disTypePrint:disTypePrint,
      sideBarSelect:{files:[]},
      heightSideBar:'29.7cm',
      defaultFont:this.props.defaultFont,
      showSidebar:false,
      optionSeting:this.props.optionSeting,
      optionSize:this.props.optionSize,
      optionSizeFormat:this.props.size
    }
  }

  printDoc() {
    if ((this.props.showSetting&&this.state.showSidebar)||this.props.isDelayPrint) {
      if (this.props.showSetting&&this.state.showSidebar)
        this.setState({showSidebar:false})
      setTimeout(() => {
        window.print() 
      },500)
    } else {
      window.print()   
    }

    if(this.props.onPrintDoc!==undefined){
      this.props.onPrintDoc()
    }
  }

  onRowsPerPageChange(e) {
    this.setState({defaultRows:e})
    if(this.props.onRowsPerPageChange!==undefined){
      this.props.onRowsPerPageChange(e)
    }
  }

  onTypePrintChange(e) {
    this.setState({defaultTypePrint:e.value})
    if(this.props.onTypePrintChange!==undefined){
      this.props.onTypePrintChange(e.value)
    }
  }

  onSideBarImgChange(index,e) {
    let _return = {index:index}
    this.props.onSideBarSelect(_return)
  }

  onFontClick(size,e) {
    this.props.onFontClick(size)
  }

  onShowBgChange() {
    this.props.onShowBgChange()
  }

  onSetting(){
    this.setState({showSidebar:!this.state.showSidebar})
  }

  onOptionSetingChange(index,e) {
    let {optionSeting} = this.state
    optionSeting[index].value = e.target.value
    this.setState({optionSeting:optionSeting})
  }

  onOptionSetingClick() {
    this.props.onOptionSetingChange(this.state.optionSeting)
  }

  onCheckOptionSetingChange(value,index) {
    let {optionSeting} = this.state

    if (optionSeting[index].type==='text')
      return false

    if (value)
      optionSeting[index].value = false
    else if (!value)
      optionSeting[index].value = true
      
    this.setState({optionSeting:optionSeting})  
    this.props.onOptionSetingChange(optionSeting)
  }

  onOptionSizeChange(size) {
    let {optionSize} = this.state
    optionSize = size.value
    this.setState({optionSize:optionSize})
    this.props.onOptionSizeChange(size)
  }

  onOptionSizeFormatChange(sizeFormat) {
    let {optionSizeFormat} = this.state
    optionSizeFormat = sizeFormat.value
    this.setState({optionSizeFormat:optionSizeFormat})
    this.props.onOptionSizeFormatChange(sizeFormat)
  }

  renderOptionSize() {
    let {isPaperConfig} = this.props
    let options = [{label:'A4',value:'A4'},{label:'Letter',value:'Letter'}]
    if (!isPaperConfig) {
      options = [{label:'A4',value:'A4'},{label:'A5',value:'A5'}]
    }
    return(
      <FormGroup className='font-print' style={{display:'inline-block',width:'90px'}}>
        <Select
          clearable={false}
          name="form-field-name"
          value={this.state.optionSize}
          options={options}
          onChange={this.onOptionSizeChange.bind(this)}
        />
      </FormGroup>
    )
  }

  renderPageNumber(pageAt,totalPage){
    if(this.props.showPageNumber&&this.props.page===false){
      return (
        <header className={'align-right ' + (this.props.size==='portrait'?'no-of-page':'')}>{pageAt+'/'+totalPage}</header>              
      )
    } else if (this.props.page!==false) {
      return(
        <header className={'align-right ' + (this.props.size==='portrait'?'no-of-page':'')}>{this.props.page[pageAt-1].page+'/'+this.props.page[pageAt-1].total_page}</header>
      )
    } else {
      return(<header className='no-of-page'><br/></header>)
    }
  }

  renderPage(){
    if(this.props.children.length>1){
      return(
        <div className='x-table' style={{overflowX:'auto'}}>
          <table className='table table-print-preview'>
            <tbody>
              <tr>
                {this.props.sideBar&&this.props.sideBarData.files.length>0?this.renderSideBar():''}
                <td id='container-a4'>
                  <div id='a4-scroll' style={{marginTop:'150px',height:(this.props.sideBar?'29.7cm':'100%'),overflowY:(this.props.sideBar?'auto':'unset')}}>
                  {
                    this.props.children.map((item,index)=> {
                      let mg = '0 15px 0 auto'
                      if (index>0)
                        mg = '150px 15px 0 auto'
                      return(
                        <div key={index} id={'preview-'+index} className={this.props.size+' '+this.props.onlineview}>
                          <div style={{margin:(this.props.sideBar&&this.props.sideBarData.files.length>0?mg:'')}} className={this.props.size+' '+this.props.sliptable+' iv-olview '+(index===0?'first-page':'')}>
                            {this.renderPageNumber(index+1,this.props.children.length)}              
                            {item}
                          </div> 
                        </div>
                      )
                    })
                  }
                  </div>
                </td>
                {this.props.sideBar&&this.props.sideBarData.files.length>0?this.props.renderSideBarRight():''}
              </tr>
            </tbody>
          </table>
        </div>
      )   
    } else {
      return(
        <div className='x-table' style={{overflowX:'auto'}}>
          <table className='table table-print-preview'>
            <tbody>
              <tr>
                {this.props.sideBar&&this.props.sideBarData.files.length>0?this.renderSideBar():''}
                <td id='container-a4'>
                  <div id="capture" className={this.props.size+' '+this.props.onlineview}>
                    <div style={{margin:(this.props.sideBar&&this.props.sideBarData.files.length>0?'150px 15px 0 0':'')}} className={this.props.size+' '+this.props.sliptable+' iv-olview one-page'}>
                      {this.props.page===false?<header className="align-center header-one-page"></header>: <header className={'align-right ' + (this.props.size==='portrait'?'no-of-page':'')}>{this.props.page!==false&&this.props.page.length>0?this.props.page[0].page+'/'+this.props.page[0].total_page:''}</header>}
                      {this.props.children}
                    </div>  
                  </div>     
                </td>
                {this.props.sideBar&&this.props.sideBarData.files.length>0?this.props.renderSideBarRight():''}
              </tr>
            </tbody>
          </table>
        </div>           
      )
    }
  }

  renderSideBar() {
    // let {heightSideBar} = this.state
    return(
      <td className="sub-sliptable-box" style={{width:'21%'}}>
        <div style={{marginTop:'150px',marginLeft:'auto',overflowY:'auto',height:'29.7cm',width:'4.7cm'}}>
          {this.renderRowSideData()}
        </div>
      </td>  
    )
  }

  renderRowSideData() {
    let {sideBarData,sideBarRelated} = this.props

    return(
      sideBarData.files.map((item,index)=> {
        return(
          <div style={{marginTop:(index>0?'15px':'')}} className='sub-sliptable' key={index}>
            <div>  
              <header>
                <Checkbox
                  onChange={this.onSideBarImgChange.bind(this,index)}
                  checked={sideBarRelated.checkedIndex.indexOf(index)!==-1?true:false}
                  checkboxClass="icheckbox_minimal"
                  increaseArea="20%"
                  label={''}
                >
                </Checkbox>
              </header>
            </div>
            <div style={{marginTop:'30px',textAlign:'center'}}>
              <LazyLoad height={1122.519685} overflow={true}>
                <img src={item.thumbnailUrl} />
              </LazyLoad>
            </div> 
            <div className='text-right'>
              <small style={{fontSize:'10px'}}>{index+1}/{sideBarData.files.length}</small>
            </div> 
          </div>
        )
      })
    )
  }

  renderOptionSizeFormat() {
    return(
      <FormGroup className='font-print' style={{display:'inline-block',width:'100px'}}>
        <Select
          clearable={false}
          value={this.state.optionSizeFormat}
          options={[{label:'แนวนอน',value:'landscape'},{label:'แนวตั้ง',value:'portrait'}]}
          onChange={this.onOptionSizeFormatChange.bind(this)}
        />
      </FormGroup>
    ) 
  }

  renderFontClick() {
    return(
      <FormGroup style={{display:'inline-block'}}>
        <div className="font-print" style={{cursor:'pointer'}}>
          <span onClick={this.onFontClick.bind(this,'sm')} style={{fontSize:'22px',fontWeight:'normal',marginRight:'15px'}}>A</span>
          <span onClick={this.onFontClick.bind(this,'md')} style={{fontSize:'30px',fontWeight:'600',marginRight:'15px'}}>A</span>
          <span onClick={this.onFontClick.bind(this,'lg')} style={{fontSize:'40px',fontWeight:'900'}}>A</span>
        </div>
      </FormGroup>
    )
  }

  renderBgChange() {
    return(
      <FormGroup className='font-print' style={{display:'inline-block'}}>
        <Checkbox
          onChange={this.onShowBgChange.bind(this)}
          checked={this.props.showBg}
          checkboxClass="icheckbox_minimal"
          increaseArea="20%"
          label={' แสดงภาพพื้นหลัง'}
        >
        </Checkbox>
      </FormGroup>
    )
  }

  renderOptionSeting() {
    let {optionSeting} = this.state
    let {isPaperConfig} = this.props
    if (optionSeting.length===0) {
      return(
        <li className=''>
          <a className='text-center'>ไม่พบข้อมูล</a>
        </li>
      )
    } else {
      return(
        optionSeting.map((item,index)=>{
          if (isPaperConfig) {
            return(
              <li key={index} className=''>
                <a className=''>
                  {item.title}
                  <div style={{display:'flex'}}>
                    <FormControl className='text-center' style={{width:'40%'}} onChange={this.onOptionSetingChange.bind(this,index)} value={item.value} />&nbsp;
                    <button className='btn btn-xs btn-success' onClick={this.onOptionSetingClick.bind(this)}>ตั้งค่า</button>
                  </div>
                </a>
              </li>
            )
          } else {
            if (item.type==='text') {
              return(
                <li key={index} className=''>
                  <a className=''>
                    {item.title}
                    <div style={{display:'flex'}}>
                      <FormControl className='text-center' style={{width:'40%'}} onChange={this.onOptionSetingChange.bind(this,index)} value={item.value} />&nbsp;
                      <button className='btn btn-xs btn-success' onClick={this.onOptionSetingClick.bind(this)}>ตั้งค่า</button>
                    </div>
                  </a>
                </li>  
              )
            } else {
              return(
                <li key={index} className=''>
                  <a className=''>
                    <Checkbox
                      onChange={this.onCheckOptionSetingChange.bind(this,item.value,index)}
                      checked={item.value?true:false}
                      checkboxClass="icheckbox_square-blue"
                      increaseArea="20%"
                      label={' '+item.title}
                    >
                    </Checkbox>
                  </a>
                </li>
              )
            }  
          }  
        })
      )
    }  
  }

  renderControlSidebar(){
      let className = this.state.showSidebar?'control-sidebar-open':''
      return (
        <aside className={"font-print control-sidebar control-sidebar-dark "+className}>
          <ul className='nav nav-tabs control-sidebar-tabs' style={{position:(this.state.showSidebar?'fixed':''),width:'230px',height:'80%',overflowY:'scroll'}}>  
            {this.props.renderOptionSeting!=undefined?this.props.renderOptionSeting():this.renderOptionSeting()}
            <li>{this.props.renderCustomSetting!==undefined?this.props.renderCustomSetting():''}</li>
          </ul>        
        </aside>
      )  
  }

  render() {
    const {leftBarTitle} = this.props
    return (
      <div className={this.state.body_print}>

        <div id="wrapper">
          <div id="hide2" className="header-bottom-fix">
            <div className={this.state.headerContent_fix} style={{textAlign:"left"}}>
              <div className="header-content-left float-left">
                <div className="hide-title">
                  <a><span id="id-title" className="font-print">{leftBarTitle}</span></a>
                </div>  
                <div className="hide-btn-print">
                  <div className="ui button button-red" onClick={this.printDoc.bind(this)}>
                    พิมพ์เอกสาร
                  </div>
                </div>  
              </div>
              <div className="header-content-right float-right">
                <Form inline>
                  <FormGroup style={{display:'inline-block'}}>
                    <ControlLabel className="font-print" style={{fontSize:'16px',display:this.state.disPerPage}}>จำนวนแถวต่อหน้า</ControlLabel>
                  </FormGroup>
                  &nbsp;
                  <FormGroup style={{display:'inline-block'}}>
                    <DropdownButton id='print-preview-dd' bsStyle={'default'} title={this.state.defaultRows} onSelect={this.onRowsPerPageChange.bind(this)} style={{display:this.state.disPerPage}}>
                      {this.props.rowAuto?<MenuItem key={'auto'} eventKey={'แถวอัตโนมัติ'}>แถวอัตโนมัติ</MenuItem>:''}
                      {this.state.optionsRows.map((item,index)=>(
                        <MenuItem key={index} eventKey={item}>{item}</MenuItem>  
                      ))}
                    </DropdownButton>
                  </FormGroup>
                  &nbsp;
                  {this.props.onOptionSizeFormatChange!==undefined?this.renderOptionSizeFormat():''}      
                  &nbsp; 
                  {this.props.onFontClick!=undefined?this.renderFontClick():''}
                  &nbsp;
                  {this.props.onShowBgChange!=undefined?this.renderBgChange():''}
                  &nbsp;
                  <FormGroup style={{display:'inline-block'}}>
                    <ControlLabel className="font-print" style={{fontSize:'16px',display:this.state.disTypePrint}}>พิมพ์เป็น</ControlLabel>
                  </FormGroup>
                  &nbsp;
                  <FormGroup className='select-type-print' style={{display:'inline-block'}}>
                    <Select
                      clearable={false}
                      name="form-field-name"
                      value={this.state.defaultTypePrint}
                      options={[{label:'ไม่มี',value:'0'},{label:'ต้นฉบับ',value:'1'},{label:'สำเนา',value:'2'},{label:'ทั้งคู่',value:'3'}]}
                      style={{width:'80px',display:this.state.disTypePrint}}
                      onChange={this.onTypePrintChange.bind(this)}
                    />
                  </FormGroup>
                  &nbsp;
                  {this.props.optionSize!=false?this.renderOptionSize():''}
                  &nbsp;
                  <FormGroup style={{display:'inline-block'}}>
                    <div className="ui button button-red float-right" onClick={this.printDoc.bind(this)}>
                      พิมพ์เอกสาร
                    </div>
                  </FormGroup>
                  &nbsp;
                  <FormGroup style={{display:(this.props.showSetting)?'':'none'}}>
                    <Button onClick={this.onSetting.bind(this)}><FontAwesome name='gears'/></Button>
                  </FormGroup>
                </Form>  
              </div>
            </div>
          </div>  
          <div className="clear"></div>
          <div id="content">
            {this.renderPage()}
          </div>
          
        </div>
        <div id="footer">
          <div id={this.state.footerContent} className="font-print">
            Copyright © 2016-{new Date().getFullYear()} CK-BOSS  All rights reserved.
          </div>
        </div>
        {this.renderControlSidebar()}
        <div className="control-sidebar-bg"></div>
      </div>
    )
  }
}  

PrintPreview.defaultProps = {
  size:'portrait',  
  leftBarTitle:'ข้อมูลเอกสาร',
  sideBar:false,
  sideBarData:{files:[]},
  sideBarRelated:{checkedIndex:[]},
  defaultRowPerPage:10,
  startRowPerPage:10,
  endRowPerPage:20,
  showPageNumber:true,
  page:false,
  defaultTypePrint:'3',
  sliptable:'sliptable-page-desktop',
  defaultFont:'sm',
  showBg:false,
  rowAuto:false,
  showSetting:false,
  optionSeting:[],
  sideBarPaperConfig:false,
  optionSize:false,
  onlineview:'a4-onlineview',
  isPaperConfig:true,
  isDelayPrint:false
}
export default PrintPreview;


// WEBPACK FOOTER //
// ./src/view/print/PrintPreview.js